import React, { useState, useEffect } from 'react';
import './About.css';

function About() {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      const response = await fetch('/api/about');
      const data = await response.json();
      setContent(data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching about content:', error);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <h1 className="about-title">{content?.title || 'Σχετικά με εμάς'}</h1>
          <p className="about-subtitle">{content?.subtitle || 'Η ιστορία μας'}</p>
        </div>
      </section>

      {/* Main Content */}
      <section className="about-content">
        <div className="container">
          <div className="content-wrapper">
            {/* Mission Section */}
            {content?.mission && (
              <div className="content-section mission-section">
                <div className="section-icon">🎯</div>
                <h2>Η Αποστολή μας</h2>
                <div 
                  className="section-text"
                  dangerouslySetInnerHTML={{ __html: content.mission }}
                />
              </div>
            )}

            {/* Vision Section */}
            {content?.vision && (
              <div className="content-section vision-section">
                <div className="section-icon">🚀</div>
                <h2>Το Όραμά μας</h2>
                <div 
                  className="section-text"
                  dangerouslySetInnerHTML={{ __html: content.vision }}
                />
              </div>
            )}

            {/* Values Section */}
            {content?.values && (
              <div className="content-section values-section">
                <div className="section-icon">⭐</div>
                <h2>Οι Αξίες μας</h2>
                <div 
                  className="section-text"
                  dangerouslySetInnerHTML={{ __html: content.values }}
                />
              </div>
            )}

            {/* Story Section */}
            {content?.story && (
              <div className="content-section story-section">
                <div className="section-icon">📖</div>
                <h2>Η Ιστορία μας</h2>
                <div 
                  className="section-text"
                  dangerouslySetInnerHTML={{ __html: content.story }}
                />
              </div>
            )}

            {/* Team Section */}
            {content?.team && (
              <div className="content-section team-section">
                <div className="section-icon">👥</div>
                <h2>Η Ομάδα μας</h2>
                <div 
                  className="section-text"
                  dangerouslySetInnerHTML={{ __html: content.team }}
                />
              </div>
            )}

            {/* Contact CTA */}
            <div className="about-cta">
              <h3>Θέλετε να μάθετε περισσότερα;</h3>
              <p>Επικοινωνήστε μαζί μας και θα χαρούμε να σας βοηθήσουμε</p>
              <a href="/contact" className="btn btn-primary btn-large">
                Επικοινωνία
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
